"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnNameProperty = exports.resultsTableColumnNamePropertyDefinition = void 0;
exports.resultsTableColumnNamePropertyDefinition = {
    view: { label: 'Results Table Column Name' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
        {
            name: 'pattern',
            argument: '^[a-z][a-zA-Z]+[0-9]*$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'results-table-column-name',
};
const isResultsTableColumnNameProperty = (prop) => {
    return prop.name === exports.resultsTableColumnNamePropertyDefinition.name;
};
exports.isResultsTableColumnNameProperty = isResultsTableColumnNameProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tbmFtZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtY29sdW1uLW5hbWUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx3Q0FBd0MsR0FBRztJQUN0RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsMkJBQTJCLEVBQUU7SUFDNUMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSx3QkFBd0I7U0FDbkM7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsMkJBQTJCO0NBQ0YsQ0FBQTtBQUkxQixNQUFNLGdDQUFnQyxHQUFHLENBQUMsSUFBa0IsRUFBMEMsRUFBRTtJQUM3RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssZ0RBQXdDLENBQUMsSUFBSSxDQUFBO0FBQ3BFLENBQUMsQ0FBQTtBQUZZLFFBQUEsZ0NBQWdDLG9DQUU1QyJ9